import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import LanguageSelector from 'Components/General/LanguageSelector'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

/** @notExported */
interface ILoginPageCardProps {
  /** Card header. */
  header: string
  /** Card avatar. */
  avatar?: React.ReactNode
  /** Card children. */
  children: React.ReactNode
}

/**
 * Login page card component.
 *
 * @returns Login page card component.
 * @notExported
 */
const LoginPageCard: React.FC<ILoginPageCardProps> = ({ header, avatar, children }) => {
  const { i18n } = useTranslation()

  const changeLanguage = useCallback(
    (language: string) => {
      i18n.changeLanguage(language)
    },
    [i18n]
  )

  return (
    <Card
      sx={{
        alignItems: 'center',
        margin: 'auto',
      }}
      elevation={3}
    >
      <CardHeader
        sx={{ textTransform: 'none' }}
        title={header}
        avatar={avatar ?? null}
        action={<LanguageSelector setLanguage={changeLanguage} global={true} id="login-language" />}
      />
      {children}
    </Card>
  )
}

export default LoginPageCard
